import { useFetch } from '@ohpen/react-utils';
import * as pmpSdk from '@pmp/api';

type FunctionOnly<T> = {
  [K in keyof T as T[K] extends (...args: any[]) => Promise<any> ? K : never]: T[K];
};

function usePmpFetch<P extends keyof FunctionOnly<typeof pmpSdk>>(methodName: P) {
  return useFetch(pmpSdk as FunctionOnly<typeof pmpSdk>, methodName);
}

export { usePmpFetch };
